'use client';
import React, { useEffect, useMemo, useState } from 'react';
import { getCookie } from 'cookies-next';
import { useHits, InstantSearch, Configure, useInstantSearch } from 'react-instantsearch';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProductItem from '@/components/customercenter-ui/components/home/productListCarousel/productItem';
import Loader from '@/customercenter-ui/components/ui/loader';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { createAlgoliaLiteClient, wrapInstantSearchClient } from '@/helpers/algolia/algoliaV5';
import { swiperConfig } from '@/helpers/utils/swiperConfig';
import { ALOGLIA_SUCCESS_STATUS, COOKIE_KEYS } from '../../../../../constants/constant';

const createSearchClient = (projectSettings: ProjectSettings) =>
  wrapInstantSearchClient(createAlgoliaLiteClient(projectSettings?.algoliaAppId, projectSettings?.algoliaApiKey));

const GenericWidget: React.FC<any> = ({ data, upSell = false }: any) => {
  const projectSettings: ProjectSettings = useProjSettings();
  const [loading, setLoading] = useState(false);
  const searchClient = useMemo(() => createSearchClient(projectSettings), [projectSettings]);

  const indexName = useMemo(() => {
    const currentSite = getCookie(COOKIE_KEYS.selectedSite);
    switch (data?.widgetData?.selectOption) {
      case 'productWidget':
        return `products_${currentSite}`;
      case 'categoryWidget':
        return `categories_${currentSite}`;
      case 'brandWidget':
        return `brands_${currentSite}`;
      default:
        return `products_${currentSite}`;
    }
  }, [data?.selectOption]);

  const GenericAlgoliaCarousel = (props: any) => {
    const { hits } = useHits(props);
    const { status } = useInstantSearch();
    useEffect(() => {
      if (status === ALOGLIA_SUCCESS_STATUS) {
        setLoading(false);
      } else {
        setLoading(true);
      }
    }, [status]);
    const generic4Layout = (
      <Swiper {...swiperConfig} className="mySwiper multiSlide">
        {hits?.map((hit: any, index: number) => (
          <SwiperSlide key={hit?.objectID}>
            <ProductItem product={hit} upSell={upSell} />
          </SwiperSlide>
        ))}
      </Swiper>
    );
    return generic4Layout;
  };

  return (
    <InstantSearch
      indexName={indexName}
      routing={false}
      insights={false}
      key={'algolia-client'}
      future={{
        persistHierarchicalRootCount: true,
        preserveSharedStateOnUnmount: true,
      }}
      searchClient={searchClient}
    >
      {loading && <Loader />}
      <Configure
        query={data?.widgetData?.widgetQuery}
        hitsPerPage={data?.widgetData?.maxWidgetItemsPerPage || 5}
        clickAnalytics={true}
      />
      <GenericAlgoliaCarousel />
    </InstantSearch>
  );
};

export default GenericWidget;
